export default {
  searchFromData: {
    type: Object,
    default: () => ({}),
  },
  //查询的高级查询地址
  criteriaFormUrl: {
    type: String,
    default: '',
  },
  //查询表单列表定义配置获取URL
  searchTableColumnDefUrl: {
    type: String,
    default: '',
  },
  //分类树的接口
  treeClassifyUrl: {
    type: String,
    default: '~static/mock/treeClassifyData.json',
  },
  // //获取分类树数据的请求类型
  treeClassifyType: {
    type: String,
    default: 'get',
  },
  ////获取分类树数据的参数
  treeClassifyParams: {
    type: Object,
    default: () => ({}),
  },

  // 获取表单内容
  urlGetOfEdit: {
    type: String,
    default: 'null',
  },
  //请求方式
  reaquestType: {
    type: String,
    default: 'get',
  },
  //请求参数
  requestParams: {
    type: Object,
    default: () => ({}),
  },
  //左侧分类数传递的参数名称
  treeClassifyRequestParamName: {
    type: String,
    default: 'id',
  },
  //左侧分类数传递的参数值
  treeClassifyRequestParamValue: {
    type: String,
    default: 'id',
  },
  // 表单定义配置Url
  formItemsDefUrl: {
    type: String,
    default: null,
  },
  // 表单定义配置
  formItemsDef: {
    type: Array,
  },
  // 表单Form配置
  propsForm: {
    type: Object,
    default: () => {
      return {
        // 是否开启行内表单模式
        inline: true,
        // 表单域标签的位置，可选值为 left、right、top
        labelPosition: 'top',
        // //表单域标签的宽度，所有的 FormItem 都会继承 Form 组件的 label-width 的值
        // labelWidth: 0,
        // 是否显示校验错误信息
        showMessage: true,
        // 原生的 autocomplete 属性，可选值为 off 或 on
        autocomplete: 'off',
      }
    },
  },
  onSide: {
    type: Boolean,
    default: false,
  },
  useBackCount: {
    // 用于价格管理中反算
    type: String,
    default: null,
  },
  initFormData: {
    type: Object,
    default: null,
  },
  specialState: {
    //自定义的store初始状态
    type: Object,
    default: () => ({}),
  },
  specialMutations: {
    //自定义的store初始Mutations
    type: Object,
    default: () => ({}),
  },
  specialActions: {
    //自定义的store初始Actions
    type: Object,
    default: () => ({}),
  },
  //传递tab 传递过来的的参数
  tabs: {
    type: Array,
    default: () => [
      {
        componentName: 'upAndDown',
        tabTitle: '跟台扫码',
        componentProps: {
          topTableColumnDefUrl: '~static/mock/dataTable/column.json',
          treeRes: "data.code + '_' + data.bath",
          getTopDataUrl: '',
          getBottomDataUrl: '',
          requestType: 'get',
          topRequestParams: {},
          bottomRequestParams: {},
          mark: '',
          topData: [
            {
              plan: 8,
              amount: 2,
              master: true,
              code: 'aaaaa',
              bath: 'qqqqq',
            },
            {
              plan: 9,
              amount: 23,
              master: false,
              code: 'aaaaa',
              bath: 'qqqqq',
            },
            {
              plan: 45,
              amount: 65,
              master: true,
              code: 'sssss',
              bath: 'wwwww',
            },
            {
              plan: 15,
              amount: 222,
              master: false,
              code: 'sssss',
              bath: 'wwwww',
            },
            {
              plan: 13,
              amount: 12,
              master: true,
              code: 'eeeee',
              bath: 'wwwww',
            },
          ],
          bottomData: [
            {
              plan: 8,
              amount: 2,
              master: true,
              code: 'aaaaa',
              bath: 'qqqqq',
            },
            {
              plan: 9,
              amount: 23,
              master: false,
              code: 'aaaaa',
              bath: 'qqqqq',
            },
          ],
        },
      },
      {
        componentName: 'upAndDown',
        tabTitle: '备货扫码',
        componentProps: {
          topTableColumnDefUrl: '~static/mock/dataTable/column.json',
          treeRes: "data.code + '_' + data.bath",
        },
      },
      {
        componentName: 'crudDataTable',
        tabTitle: '手术记账',
        componentProps: {
          tableColumnDefUrl: '~static/mock/dataTable/column.json',
          value: [
            {
              plan: 8,
              amount: 2,
              master: true,
              code: 'aaaaa',
              bath: 'qqqqq',
            },
            {
              plan: 9,
              amount: 23,
              master: false,
              code: 'aaaaa',
              bath: 'qqqqq',
            },
            {
              plan: 45,
              amount: 65,
              master: true,
              code: 'sssss',
              bath: 'wwwww',
            },
            {
              plan: 15,
              amount: 222,
              master: false,
              code: 'sssss',
              bath: 'wwwww',
            },
            {
              plan: 13,
              amount: 12,
              master: true,
              code: 'eeeee',
              bath: 'wwwww',
            },
          ],
        },
      },
    ],
  },
  // 默认 tab
  activeTabName: {
    type: String,
    default: '库存添加',
  },
  // 不显示树形
  hiddenTreeClassify: {
    type: Boolean,
    default: false,
  },
  hiddenByDepartment: { type: Boolean, default: false },
  banClickExpression: {
    type: String,
    default: '!data.lead',
  },
  /** @deprecated #6447，获取查看敏感数据权限的接口地址 */
  getSensitiveDataUrl: {
    type: String,
    default: '',
  },
  /** @deprecated #6447，获取查看敏感数据权限的接口参数 */
  getSensitiveDataParams: {
    type: Object,
    default() {
      return {}
    },
  },
}
